import React from 'react';
import RevelarSeccion from "./ParallaxEffect";
import AnimationSection from "./AnimationSection";
import {Container} from "react-bootstrap";

interface ContentWrapperProps {
    contentKey: string;
    currentContent: any;
}

const ContentWrapper: React.FC<ContentWrapperProps> = ({currentContent, contentKey}) => {
    return (
        <>
            <div id={contentKey} style={{height: "0px"}}></div>

            <RevelarSeccion
                isVideo={currentContent.isVideo}
                imageSrc={`/assets/${currentContent.imagen}`}
                className={currentContent.className}
                isAnimation={currentContent.isAnimation}
            >
                <div className="sticky-section d-flex flex-column align-items-start">
                    <div className="w-100 d-flex justify-content-center gap-4">
                        <AnimationSection treshold={0.9} animation="animate__zoomInUp">
                            <div
                                className={`tituloContent text-center noto-sans-condensed-69 ${currentContent.colorTitulo}`}>{currentContent.titulo}</div>
                        </AnimationSection>
                    </div>
                    <div className="w-100 d-flex justify-content-center mt-auto p-5 mb-5 bd-highlight">
                        <AnimationSection treshold={0.5} animation="animate__fadeIn">
                            <Container>
                                <div className={currentContent.colorTexto} style={{paddingBottom: "100px"}}
                                     dangerouslySetInnerHTML={{__html: currentContent.text}}/>
                            </Container>
                        </AnimationSection>
                    </div>
                </div>
            </RevelarSeccion>
        </>
    )
}

export default ContentWrapper;